import * as React from 'react';

import FocusManagerFacade from '../../../FocusManager/FocusManagerFacade';

import fallbackFocusManagerFacade from './Util/fallbackFocusManagerFacade';

/**
 * Allows consumer components to access the focus manager instance anywhere within a provider's
 * subtree.
 */

const FocusManagerContext = React.createContext<FocusManagerFacade>(fallbackFocusManagerFacade);

export default FocusManagerContext;
